<script setup lang="ts"></script>

<template>
  <icon name="lucide:chevron-right" />
</template>

<style scoped></style>
